import type { Extraction } from "../../../api/knowledgeData/knowledgeDataDecoders";

/** The answers of an acceptance step: its part `choice` (ADR-0026 slice 3a). */
export type ResultChoice = "accept" | "reject";

/** The accept or reject decision a result holds, last, if it does. */
export function recordedDecision(extraction: Pick<Extraction, "decisions">): { kind: ResultChoice; comment: string } | undefined {
  const last = extraction.decisions.at(-1);
  return last !== undefined && (last.kind === "accept" || last.kind === "reject") ? { kind: last.kind, comment: last.comment } : undefined;
}

/**
 * The decision an assembled vita's answer made, if it made one: one answer decides every part,
 * one by one, so the parts decided so far hold it, the same on each, and the rest may still
 * wait after a stop between them (E4). Recording it again finishes it.
 */
export function recordedVitaDecision(parts: readonly Pick<Extraction, "decisions">[]): { kind: ResultChoice; comment: string } | undefined {
  const decisions = parts.map(recordedDecision).filter((decision) => decision !== undefined);
  const first = decisions[0];
  return first !== undefined && decisions.every((decision) => decision.kind === first.kind && decision.comment === first.comment) ? first : undefined;
}
